import { useCallback } from "react"

import { AiCreditsQueryDocument, FactorialOneLayoutQuery } from "generated/resources/graphql"

import { useNavigation } from "modules/core/hooks/useNavigation"
import { useLazyQuery } from "modules/core/hooks/useQuery"
import i18n from "modules/core/lib/i18n"
import buildUrl from "modules/core/lib/buildUrl"

interface useAiChatCreditsUsageProps {
  companyId: string
  currentCompany: FactorialOneLayoutQuery["apiCore"]["companiesConnection"]["nodes"][0] | undefined
  canRequestUpsell: boolean
  showCredits: boolean
}

export const useAiChatCreditsUsage = ({
  companyId,
  currentCompany,
  canRequestUpsell,
  showCredits,
}: useAiChatCreditsUsageProps) => {

  const { navigation } = useNavigation()
  const [fetchCredits] = useLazyQuery(AiCreditsQueryDocument)

  const fetchUsage = useCallback(async () => {
    const result = await fetchCredits({ variables: { companyId } })
    const remaining =
      result.data?.aiCredits.creditStatusesConnection.nodes[0]?.remainingCredits ?? 0
    const total =
      result.data?.aiCredits.creditStatusesConnection.nodes[0]?.monthlyAllocation ?? 500

    const used = total - remaining

    return { used, total }
  }, [fetchCredits, companyId])

  if (!showCredits) return undefined

  const upgradePlanUrl = canRequestUpsell
    ? navigation.discover.marketplaceModules.item.fullPath({ id: "one" }) + "?action=init-self-upsell"
    : undefined

  return {
    fetchUsage,
    companyName: currentCompany?.name,
    companyLogoUrl: buildUrl((currentCompany?.workspaceLogo || currentCompany?.logo) ?? undefined),
    planName: i18n.t("common.ai.credits.free_plan"),  // TODO: make it dynamic
    upgradePlanUrl
  }
}
